import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/PageHero";

export default function Glossary() {
  const [terms, setTerms] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/glossary").then((r) => setTerms(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = terms.filter(
    (t) => t.term.toLowerCase().includes(q.toLowerCase()) ||
      (t.abbr || "").toLowerCase().includes(q.toLowerCase()) ||
      t.definition.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="glossary-page">
      <PageHero
        eyebrow="Market Dictionary"
        title="Financial-Market Education Glossary"
        subtitle="A searchable glossary of essential market terms — from CPR and Camarilla to Delta, Gamma, Theta and Vega. Each definition is educational and concise."
        crumbs={[{ label: "Glossary" }]}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="relative mb-8">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <input
            value={q} onChange={(e) => setQ(e.target.value)} data-testid="glossary-search"
            placeholder="Search terms…"
            className="w-full h-12 rounded-md border border-border pl-11 pr-4 text-sm text-navy outline-none focus:ring-2 focus:ring-gold"
          />
        </div>
        {loading ? (
          <p className="text-slate-400">Loading glossary…</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4" data-testid="glossary-list">
            {filtered.map((t) => (
              <div key={t.term} className="border border-border rounded-lg p-5 bg-white" data-testid={`glossary-term-${t.term.toLowerCase().replace(/\s/g, "-")}`}>
                <div className="flex items-baseline justify-between">
                  <h3 className="font-display text-lg font-bold text-navy">{t.term}</h3>
                  <span className="text-[11px] px-2 py-0.5 rounded bg-subtle border border-border text-slate-500">{t.category}</span>
                </div>
                {t.abbr && <p className="text-xs text-gold font-medium mt-0.5">{t.abbr}</p>}
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{t.definition}</p>
              </div>
            ))}
            {filtered.length === 0 && <p className="text-slate-400">No terms found.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
